module.exports = __webpack_public_path__ + "media/images/top/voice/voice3-554c6187a0d9f252d5471ab813f7f172.png";